export const IconExit = () => (<i className='icon-exit'/>)
